export default "__VITE_ASSET__1AVEiVYV__"